import { render } from "./MenuNavBar.vue?vue&type=template&id=3cbca39f&lang=pug"
import script from "./MenuNavBar.vue?vue&type=script&lang=js"
export * from "./MenuNavBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/menu/MenuNavBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cbca39f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cbca39f', __exports__)) {
    api.reload('3cbca39f', __exports__)
  }
  
  module.hot.accept("./MenuNavBar.vue?vue&type=template&id=3cbca39f&lang=pug", () => {
    api.rerender('3cbca39f', render)
  })

}


export default __exports__